import { NgClass } from '@angular/common';
import {
  Component,
  ElementRef,
  HostListener,
  Input,
  ViewChild,
} from '@angular/core';
import { twMerge } from 'tailwind-merge';

@Component({
  selector: 'core-dropdown',
  templateUrl: './dropdown.component.html',
  standalone: true,
  imports: [NgClass],
})
export class DropdownComponent {
  @Input() dropdownClass: string = '';
  @Input() buttonClass: string = '';
  @Input() buttonLabel: string | undefined;
  @Input() contentClass: string = '';

  @ViewChild('dropdownButtonElement') dropdownButtonElement!: ElementRef;
  @ViewChild('dropdownContentElement') dropdownContentElement!: ElementRef;

  showDropdown = false;

  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }

  closeDropdown() {
    this.showDropdown = false;
  }

  get ngDropdownClass() {
    return twMerge('relative', this.dropdownClass);
  }

  get ngButtonClass() {
    return twMerge(this.buttonClass);
  }

  get ngContentClass() {
    return twMerge(
      'dropdown-content',
      'absolute',
      this.contentClass,
      !this.showDropdown ? 'hidden' : '',
    );
  }

  @HostListener('document:click', ['$event'])
  onClick(event: Event) {
    const targetElement = event.target as HTMLElement;
    if (
      !this.dropdownButtonElement.nativeElement.contains(targetElement) &&
      !this.dropdownContentElement.nativeElement.contains(targetElement)
    ) {
      this.showDropdown = false;
    }
  }
}
